export const CLEAR: "ui/CLEAR" = "ui/CLEAR";
export const SET_SIDEBAR_OPEN: "ui/SET_SIDEBAR_OPEN" = "ui/SET_SIDEBAR_OPEN";
export const SHOW_MODAL: "ui/SHOW_MODAL" = "ui/SHOW_MODAL";
export const HIDE_MODAL: "ui/HIDE_MODAL" = "ui/HIDE_MODAL";
